import { environment } from '../../../../environments/environment';

export class TransactionReportService {
  static $inject = ['RestResource', 'UtilService', 'SessionService'];

  constructor(private RestResource, private UtilService, private SessionService) {}

  utils = new this.UtilService(this);

  getFilterCriteria(field, order) {
    return {
      page: 1,
      sortedBy: field,
      sortDir: order,
    };
  }

  getTransactionsReport(filterCriteria, url) {
    filterCriteria.company_id = this.SessionService.getSelectedAccountCompany().id;

    let apiUrl = environment.apiEndpoint + url;

    return this.RestResource.request(
      'get',
      apiUrl,
      filterCriteria,
      (response) => {
        response = response.data;

        if (response.meta) {
          return {
            items: response.data,
            meta: this.utils.getItemsMetaData(response, filterCriteria),
            // stats: response.meta.stats,
          };
        } else {
          return {
            items: response.data,
          };
        }
      },
      function () {
        return {
          items: [],
          totalItems: 0,
          entryLimit: 0,
          totalPages: 0,
          stats: [],
        };
      }
    );
  }

  downloadReportXLS(filterCriteria, url) {
    let apiUrl = environment.apiEndpoint + url;

    filterCriteria.company_id = this.SessionService.getSelectedAccountCompany().id;

    return this.RestResource.request(
      'get',
      apiUrl,
      filterCriteria,
      function (response) {
        return response.data;
      },
      function () {
        // console.log(err);
      }
    );
  }

  downloadReportPDF(filterCriteria, url) {
    let apiUrl = environment.apiEndpoint + url;

    filterCriteria.company_id = this.SessionService.getSelectedAccountCompany().id;

    return this.RestResource.request(
      'get',
      apiUrl,
      filterCriteria,
      function (response) {
        return response.data;
      },
      function () {
        // console.log(err);
      }
    );
  }
}
